import {
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  RESET_PROFILE_STATE,
  GET_PROFILE_DATA_BY_TAB,
  GET_PROFILE_DATA_BY_TAB_SUCCESS,
  GET_PROFILE_DATA_BY_TAB_FAIL,
  CREATE_SALESMAN,
  CREATE_SALESMAN_SUCCESS,
  CREATE_SALESMAN_FAIL,
  DELETE_SALESMAN,
  DELETE_SALESMAN_SUCCESS,
  DELETE_SALESMAN_FAIL,
  SET_SALESMAN_AS_DEFAULT,
  SET_SALESMAN_AS_DEFAULT_SUCCESS,
  SET_SALESMAN_AS_DEFAULT_FAIL,
  REMOVE_TEAM_MEMBER,
  REMOVE_TEAM_MEMBER_SUCCESS,
  REMOVE_TEAM_MEMBER_FAIL,
  INVITE_TEAM_MEMBER,
  INVITE_TEAM_MEMBER_SUCCESS,
  INVITE_TEAM_MEMBER_FAIL,
  REINVITE_TEAM_MEMBER,
  REINVITE_TEAM_MEMBER_SUCCESS,
  REINVITE_TEAM_MEMBER_FAIL,
  REMOVE_TEAM_MEMBER_INVITATION,
  REMOVE_TEAM_MEMBER_INVITATION_SUCCESS,
  REMOVE_TEAM_MEMBER_INVITATION_FAIL,
  RESET_PROFILE_ACTION_STATE,
  UPDATE_PROFILE_VERIFICATION,
  UPDATE_PROFILE_VERIFICATION_SUCCESS,
  UPDATE_PROFILE_VERIFICATION_FAIL,
  RESET_PROFILE_VERIFICATION,
} from "./actionTypes";

//update profile
export const updateProfile = payload => {
  return {
    type: UPDATE_PROFILE,
    payload: payload,
  };
}

export const updateProfileSuccess = profile => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: profile,
});

export const updateProfileFail = payload => {
  return {
    type: UPDATE_PROFILE_FAIL,
    payload: payload,
  };
}

export const updateProfileVerification = payload => ({
  type: UPDATE_PROFILE_VERIFICATION,
  payload,
});

export const updateProfileVerificationSuccess = payload => ({
  type: UPDATE_PROFILE_VERIFICATION_SUCCESS,
  payload,
});

export const updateProfileVerificationFail = payload => ({
  type: UPDATE_PROFILE_VERIFICATION_FAIL,
  payload,
});

export const resetProfileVerification = () => ({
  type: RESET_PROFILE_VERIFICATION,
});

// Get profile data by tab
export const getProfileDataByTab = payload => ({
  type: GET_PROFILE_DATA_BY_TAB,
  payload,
});

export const getProfileDataByTabSuccess = payload => ({
  type: GET_PROFILE_DATA_BY_TAB_SUCCESS,
  payload,
});

export const getProfileDataByTabFail = error => ({
  type: GET_PROFILE_DATA_BY_TAB_FAIL,
  payload: error,
});

// Create salesman
export const createSalesman = payload => ({
  type: CREATE_SALESMAN,
  payload,
});

export const createSalesmanSuccess = payload => ({
  type: CREATE_SALESMAN_SUCCESS,
  payload,
});

export const createSalesmanFail = error => ({
  type: CREATE_SALESMAN_FAIL,
  payload: error,
});

// Delete salesman
export const deleteSalesman = payload => ({
  type: DELETE_SALESMAN,
  payload,
});

export const deleteSalesmanSuccess = payload => ({
  type: DELETE_SALESMAN_SUCCESS,
  payload,
});

export const deleteSalesmanFail = error => ({
  type: DELETE_SALESMAN_FAIL,
  payload: error,
});

// Set salesman as default
export const setSalesmanAsDefault = payload => ({
  type: SET_SALESMAN_AS_DEFAULT,
  payload,
});

export const setSalesmanAsDefaultSuccess = payload => ({
  type: SET_SALESMAN_AS_DEFAULT_SUCCESS,
  payload,
});

export const setSalesmanAsDefaultFail = error => ({
  type: SET_SALESMAN_AS_DEFAULT_FAIL,
  payload: error,
});

// Remove team member
export const removeTeamMember = payload => ({
  type: REMOVE_TEAM_MEMBER,
  payload,
});

export const removeTeamMemberSuccess = payload => ({
  type: REMOVE_TEAM_MEMBER_SUCCESS,
  payload,
});

export const removeTeamMemberFail = error => ({
  type: REMOVE_TEAM_MEMBER_FAIL,
  payload: error,
});

// Invite team member
export const inviteTeamMember = payload => ({
  type: INVITE_TEAM_MEMBER,
  payload,
});

export const inviteTeamMemberSuccess = payload => ({
  type: INVITE_TEAM_MEMBER_SUCCESS,
  payload,
});

export const inviteTeamMemberFail = error => ({
  type: INVITE_TEAM_MEMBER_FAIL,
  payload: error,
});

// Reinvite team member
export const reinviteTeamMember = payload => ({
  type: REINVITE_TEAM_MEMBER,
  payload,
});

export const reinviteTeamMemberSuccess = payload => ({
  type: REINVITE_TEAM_MEMBER_SUCCESS,
  payload,
});

export const reinviteTeamMemberFail = error => ({
  type: REINVITE_TEAM_MEMBER_FAIL,
  payload: error,
});

// Remove team member invitation
export const removeTeamMemberInvitation = payload => ({
  type: REMOVE_TEAM_MEMBER_INVITATION,
  payload,
});

export const removeTeamMemberInvitationSuccess = payload => ({
  type: REMOVE_TEAM_MEMBER_INVITATION_SUCCESS,
  payload,
});

export const removeTeamMemberInvitationFail = error => ({
  type: REMOVE_TEAM_MEMBER_INVITATION_FAIL,
  payload: error,
});


//reset
export const resetProfileState = () => {
  return {
    type: RESET_PROFILE_STATE,
  }
}

export const resetProfileActionState = () => {
  return {
    type: RESET_PROFILE_ACTION_STATE,
  }
}
